export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 font-heading">
          Pronto a scoprire{' '}
          <span className="italic font-normal">Itaobuy Sheet</span>?
        </h2>
        <p className="mt-4 text-base md:text-lg text-foreground-500 font-body">
          Visita il sito ufficiale per esplorare tutte le funzionalità e iniziare subito.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 bg-secondary-500 text-background-50 rounded-full text-base font-semibold hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap font-label"
          >
            Scopri Itaobuy Spreadsheet
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>

        <div className="mt-16">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {[
              'https://readdy.ai/api/search-image?query=Single%20classic%20leather%20loafer%20on%20warm%20sand%20background%2C%20clean%20product%20cutout%20style%2C%20soft%20studio%20lighting%20from%20above%2C%20rich%20cognac%20brown%20hue%2C%20premium%20footwear%20photography%2C%20simple%20elegant%20composition&width=200&height=200&seq=cta-01-v2&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Single%20minimalist%20backpack%20on%20light%20clay%20background%2C%20product%20cutout%20photography%2C%20soft%20front%20lighting%2C%20olive%20green%20canvas%20texture%20visible%2C%20urban%20everyday%20carry%20aesthetic%2C%20clean%20commercial%20style&width=200&height=200&seq=cta-02-v2&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Single%20elegant%20wristwatch%20on%20ivory%20surface%2C%20product%20cutout%20style%2C%20soft%20directional%20light%20creating%20subtle%20reflections%2C%20rose%20gold%20case%20with%20cream%20dial%2C%20luxury%20timepiece%20photography%2C%20refined%20minimal%20composition&width=200&height=200&seq=cta-03-v2&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Single%20pair%20of%20tortoiseshell%20sunglasses%20on%20warm%20beige%20surface%2C%20product%20cutout%20photography%2C%20soft%20diffused%20overhead%20light%2C%20classic%20elegant%20frame%20shape%2C%20luxury%20eyewear%20aesthetic%2C%20clean%20minimal%20composition&width=200&height=200&seq=cta-04-v2&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Single%20silk%20neck%20scarf%20on%20soft%20dove%20gray%20background%2C%20product%20cutout%20style%2C%20gentle%20side%20lighting%20showing%20fabric%20sheen%2C%20muted%20floral%20pattern%20in%20dusty%20rose%2C%20luxury%20accessory%20photography%2C%20elegant%20minimal%20composition&width=200&height=200&seq=cta-05-v2&orientation=squarish',
            ].map((src, i) => (
              <div key={i} className="w-24 h-24 md:w-28 md:h-28 rounded-2xl overflow-hidden bg-background-100">
                <img
                  src={src}
                  alt={`Itaobuy Spreadsheet prodotto ${i + 1}`}
                  title={`Itaobuy Spreadsheet - prodotto ${i + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}